/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export function isEmpty(str){
	if(typeof(str)==="undefined") return true;
	if(str===null) return true;
	return String(str).trim()==="";
}

export function generateRandomString(length){
	let result = '';
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
	const charactersLength = characters.length;
	let counter = 0;
	while (counter < length) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
		counter += 1;
	}
	return result;
}